// extracted by mini-css-extract-plugin
export default {"noReviewsRow":"Reviews_noReviewsRow__B+pQv","noReviewsRow_icon":"Reviews_noReviewsRow_icon__oafLM"};